import React from "react";

const UserManagementGroups = () => {
	return <div>GROUPS</div>;
};

export default UserManagementGroups;
